import InputGroup from '@appfolio/react-gears/lib/components/InputGroup';
import InputGroupAddon from '@appfolio/react-gears/lib/components/InputGroupAddon';
import React from 'react';
import NumberInput, { NumberInputProps } from './NumberInput';

export type PercentInputProps = NumberInputProps;

export default function PercentInput(props: PercentInputProps) {
  return (
    <InputGroup>
      <NumberInput {...props} />
      <InputGroupAddon addonType="append">%</InputGroupAddon>
    </InputGroup>
  );
}
